import { render, staticRenderFns } from "./CallDialog.vue?vue&type=template&id=6511228b&"
import script from "./CallDialog.vue?vue&type=script&lang=ts&"
export * from "./CallDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports